import { PlatformType, getAppVersion, getPlatformType } from '@nibfe/mkt-env-api';
const isMRN = false;
export function compareVersion(version1, version2) {
    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);
    const maxLength = Math.max(v1Parts.length, v2Parts.length);
    for (let i = 0; i < maxLength; i++) {
        const v1 = v1Parts[i] || 0;
        const v2 = v2Parts[i] || 0;
        if (v1 > v2)
            return true;
        if (v1 < v2)
            return false;
    }
    return true;
}
export function getIsSupportVap() {
    if (isMRN) {
        try {
            const version = getAppVersion();
            const platform = getPlatformType();
            const isMt = [PlatformType.mtApp, PlatformType.mtAppWebView].includes(platform);
            const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
            if (isMt && version && compareVersion(version, '12.9.400')) {
                return true;
            }
            else if (isDp && version && compareVersion(version, '11.20')) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    else {
        return true;
    }
}
